import React from 'react';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';
import { useSelector } from 'react-redux';
import { getLocalString, localNames } from 'utils/localisation.service';
import { isKtP, isProvider } from 'utils';

const ClickUpload = ({
  fileAccepts = '.xls, .doc, .pdf, .png, .jpg',
  fileLimit = 15, //Alex to zhthse
  fileCode = '',
}) => {

  const locales = useSelector(state => state.forms?.localeStrings);
  const user = useSelector(state => state.user.groups);
  return (
    <div className="custom-drag__upload-area">
      <div className="flex-column align-items-center">
        <UploadIcon className="mb-1" />
        <div className="d-flex align-items-center click-upload">
          <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD)}</div>
        </div>
        <div className="d-flex file-specs">
          {isKtP(user) || (isProvider(user) && fileCode !== 'contractProvider')?
            <span>.xls (μέγιστο μέγεθος αρχείου: 20 MB)</span>
            :
            fileCode?.includes("declar") ?
              <span>.pdf, PNG (μέγιστο μέγεθος αρχείου: 20 MB)</span>
              :
            fileCode == "investmentExpenses" ? 
              <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD3)}</div>
              :
            fileCode == "businessPlanFile" ? <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD4)}</div> :
            fileCode == "eligibilityFile" ? <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD5)}</div> :
            <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD2)}</div>
          }
        </div>
      </div>
    </div>
  );
};

export default ClickUpload;
